<template>
    <div>
        <div @mousemove="move" class="w3l-banner">
            <div :style="
                'transform: translate(' +
                (position == 'left' ? '20' : '-20') +
                'px,' +
                (position2 == 'top' ? '10' : '-10') +
                'px) scale(1.1)'
            " class="banner-image"></div>
            <div class="titleBox" :class="contType == 'e' ? 'titleBoxe' : ''">
                <div class="wow flipInX titleT1" :class="contType == 'e' ? 'titleT1e' : ''">{{ contList[contType][0] }}
                </div>
                <div class="wow flipInX titleT2" :class="contType == 'e' ? 'titleT2e' : ''">{{ contList[contType][1] }}
                </div>
                <img class="wow bounceInRight titlebgIcon1" src="../assets/img/Overlay/icon.png" alt="" />
                <img class="wow bounceInUp titlebg" src="../assets/img/Overlay/person.png" alt="" />
            </div>
        </div>

        <div class="contBox">
            <el-carousel class="wow bounceInUp " ref="page" style="width:1200px;" height="904px" :interval="5000"
                @change="pageChange" arrow="never">
                <el-carousel-item v-for="(item, index) in itemList[contType]" :key="index" :name="index + ''">
                    <div class="crdBox">
                        <img class="img2" src="../assets/img/Overlay/Group 2@2x(1).png" alt="">
                        <img class="img3" src="../assets/img/Overlay/Group 2@2x.png" alt="">

                        <img v-if="index == 0" class="img1" src="../assets/img/Overlay/Image - Header 5@2x.png" alt="">
                        <img v-if="index == 1" class="img1" src="../assets/img/Overlay/Image - Header 5.png" alt="">
                        <img v-if="index == 2" class="img1" src="../assets/img/Overlay/Image - Header 5@2x(1).png" alt="">
                        <img v-if="index == 3" class="img1" src="../assets/img/Overlay/Image - Header 5@2x(2).png" alt="">
                        <img v-if="index == 4" class="img1" src="../assets/img/Overlay/Image - Header 5@2x(3).png" alt="">
                        <img v-if="index == 5" class="img1" src="../assets/img/Overlay/Image - Header 5@2x(4).png" alt="">
                        <img v-if="index == 6" class="img1" src="../assets/img/Overlay/Image - Header 5f.png" alt="">
                        <img v-if="index == 7" class="img1" src="../assets/img/Overlay/Image - Header 5(2).png" alt="">
                        <img v-if="index == 8" class="img1" src="../assets/img/Overlay/Image - Header 5(4).png" alt="">
                        <img v-if="index == 9" class="img1" src="../assets/img/Overlay/Image - Header 5(1).png" alt="">
                        <img v-if="index == 10" class="img1" src="../assets/img/Overlay/Image - Header 5(3).png" alt="">
                        <img v-if="index == 11" class="img1" src="../assets/img/Overlay/Image - Header 5(5).png" alt="">

                        <img class="img4" src="../assets/img/Overlay/Group 5@2x.png" alt="">
                        <div class="text">{{ item }}</div>
                        <div class="line"></div>
                    </div>
                </el-carousel-item>
            </el-carousel>

            <div class="wow bounceInUp scrollBox" data-wow-delay="0.5s">
                <div class="scrollContBox">
                    <div class="scroll" ref="scroll">
                        <div class="box" v-for="(item, index) in itemList[contType]" :key="index">
                            <div :class="curIndex == index ? 'itemBox_s' : 'itemBox'" @click="clickPage(index)"
                                :id="'id' + index">
                                <template v-if="index == 0">
                                    <img v-if="index == curIndex" class="icon" src="../assets/img/Overlay/horse-toy@2x.png"
                                        alt="" />
                                    <img v-if="index != curIndex" class="icon"
                                        src="../assets/img/Overlay/horse-toy@2x的副本.png" alt="" />
                                </template>
                                <template v-if="index == 1">
                                    <img v-if="index == curIndex" class="icon"
                                        src="../assets/img/Overlay/building-skyscraper@2x的副本.png" alt="" />
                                    <img v-if="index != curIndex" class="icon"
                                        src="../assets/img/Overlay/building-skyscraper@2x.png" alt="" />
                                </template>
                                <template v-if="index == 2">
                                    <img v-if="index == curIndex" class="icon"
                                        src="../assets/img/Overlay/building-store@2x(1).png" alt="" />
                                    <img v-if="index != curIndex" class="icon"
                                        src="../assets/img/Overlay/building-store@2x.png" alt="" />
                                </template>
                                <template v-if="index == 3">
                                    <img v-if="index == curIndex" class="icon"
                                        src="../assets/img/Overlay/plane-tilt@2x(1).png" alt="" />
                                    <img v-if="index != curIndex" class="icon" src="../assets/img/Overlay/plane-tilt@2x.png"
                                        alt="" />
                                </template>
                                <template v-if="index == 4">
                                    <img v-if="index == curIndex" class="icon"
                                        src="../assets/img/Overlay/brand-youtube@2x(1).png" alt="" />
                                    <img v-if="index != curIndex" class="icon"
                                        src="../assets/img/Overlay/brand-youtube@2x.png" alt="" />
                                </template>
                                <template v-if="index == 5">
                                    <img v-if="index == curIndex" class="icon"
                                        src="../assets/img/Overlay/device-gamepad-2@2x(1).png" alt="" />
                                    <img v-if="index != curIndex" class="icon"
                                        src="../assets/img/Overlay/device-gamepad-2@2x.png" alt="" />
                                </template>
                                <template v-if="index == 6">
                                    <img v-if="index == curIndex" class="icon"
                                        src="../assets/img/Overlay/shopping-bag(1).png" alt="" />
                                    <img v-if="index != curIndex" class="icon" src="../assets/img/Overlay/shopping-bag.png"
                                        alt="" />
                                </template>
                                <template v-if="index == 7">
                                    <img v-if="index == curIndex" class="icon"
                                        src="../assets/img/Overlay/shopping-bag(11).png" alt="" />
                                    <img v-if="index != curIndex" class="icon"
                                        src="../assets/img/Overlay/shopping-bag(2).png" alt="" />
                                </template>
                                <template v-if="index == 8">
                                    <img v-if="index == curIndex" class="icon"
                                        src="../assets/img/Overlay/shopping-bag(10).png" alt="" />
                                    <img v-if="index != curIndex" class="icon"
                                        src="../assets/img/Overlay/shopping-bag(3).png" alt="" />
                                </template>
                                <template v-if="index == 9">
                                    <img v-if="index == curIndex" class="icon"
                                        src="../assets/img/Overlay/shopping-bag(9).png" alt="" />
                                    <img v-if="index != curIndex" class="icon"
                                        src="../assets/img/Overlay/shopping-bag(4).png" alt="" />
                                </template>
                                <template v-if="index == 10">
                                    <img v-if="index == curIndex" class="icon"
                                        src="../assets/img/Overlay/shopping-bag(8).png" alt="" />
                                    <img v-if="index != curIndex" class="icon"
                                        src="../assets/img/Overlay/shopping-bag(5).png" alt="" />
                                </template>
                                <template v-if="index == 11">
                                    <img v-if="index == curIndex" class="icon"
                                        src="../assets/img/Overlay/shopping-bag(7).png" alt="" />
                                    <img v-if="index != curIndex" class="icon"
                                        src="../assets/img/Overlay/shopping-bag(6).png" alt="" />
                                </template>
                                <div :class="curIndex == index ? 'name_s' : 'name'">{{ item }}</div>
                            </div>
                        </div>
                    </div>
                    <div class="mask"></div>
                    <img class="arrIcon" src="../assets/img/Overlay/arrow-down-circle@2x.png" alt="" @click="clickNext">
                </div>
            </div>
        </div>

        <div class="contBox1">
            <img class="bgIcon" src="../assets/img/Overlay/Group 2@2x.png" alt="">
            <img class="bgIcon1" src="../assets/img/Overlay/Group 2@2x(1).png" alt="">
            <Swiper :options="swiperOption" ref="mySwiper" class="sw" @ready="onSwiper" @slideChange="onSlideChange">
                <Swiper-Slide style="width: 230px;margin-left: 16px;" v-for="(item, index) in itemList[contType]"
                    :key="index">
                    <div class="itemBox_p">
                        <img class="imgBox" :src="images[index]" alt="">
                        <div v-if="phoneIndex == index" class="markBox"></div>
                        <div v-if="phoneIndex != index" class="markBox1"></div>
                        <div class="iconBox">
                            <img v-if="phoneIndex == index" class="miniIcon" :src="images1[index]" alt="">
                            <img v-if="phoneIndex != index" class="miniIcon" :src="images2[index]" alt="">
                            <div :class="phoneIndex == index ? 'iconText' : 'iconText1'">{{ itemList[contType][index] }}
                            </div>
                        </div>
                    </div>
                </Swiper-Slide>
                <Swiper-Slide style="width: 230px;margin-left: 16px;">

                </Swiper-Slide>
            </Swiper>
            <div class="wow bounceInUp pagination">
                <div class="point mgLR" :class="[phoneIndex == 0 ? 'point_s' : '']" @click="clickChangePage(0)"></div>
                <div class="point mgLR" :class="[phoneIndex == 1 ? 'point_s' : '']" @click="clickChangePage(1)"></div>
                <div class="point mgLR" :class="[phoneIndex == 2 ? 'point_s' : '']" @click="clickChangePage(2)"></div>
                <div class="point mgLR" :class="[phoneIndex == 3 ? 'point_s' : '']" @click="clickChangePage(3)"></div>
                <div class="point mgLR" :class="[phoneIndex == 4 ? 'point_s' : '']" @click="clickChangePage(4)"></div>
                <div class="point mgLR" :class="[phoneIndex == 5 ? 'point_s' : '']" @click="clickChangePage(5)"></div>
                <div class="point mgLR" :class="[phoneIndex == 6 ? 'point_s' : '']" @click="clickChangePage(6)"></div>
                <div class="point mgLR" :class="[phoneIndex == 7 ? 'point_s' : '']" @click="clickChangePage(7)"></div>
                <div class="point mgLR" :class="[phoneIndex == 8 ? 'point_s' : '']" @click="clickChangePage(8)"></div>
                <div class="point mgLR" :class="[phoneIndex == 9 ? 'point_s' : '']" @click="clickChangePage(9)"></div>
                <div class="point mgLR" :class="[phoneIndex == 10 ? 'point_s' : '']" @click="clickChangePage(10)"></div>
                <div class="point mgLR" :class="[phoneIndex == 11 ? 'point_s' : '']" @click="clickChangePage(11)"></div>
            </div>
        </div>
    </div>
</template>
<script>


import { WOW } from "wowjs";
import { Swiper, SwiperSlide } from "vue-awesome-swiper";
import { Autoplay } from 'swiper'

export default {
    components: {
        Swiper,
        SwiperSlide,
    },
    name: "index",
    data: (vm) => {
        return {
            bodyW: 0,
            bodyY: 0,
            position: "",
            position2: "",
            contList: {
                z: [
                    "行业覆盖",
                    "主要为跨境外贸、旅游航空、软件游戏、数字版权、教育培训等\n诸多跨境互联网B2C(B)商业模式提供符合行业发展趋势的一站式\n跨境支付解决方案和服务。",
                ],
                f: [
                    "行业覆盖",
                    "主要为跨境外贸、旅游航空、软件游戏、数字版权、教育培训等\n诸多跨境互联网B2C(B)商业模式提供符合行业发展趋势的一站式\n跨境支付解决方案和服务。",
                ],
                e: [
                    'Industrial Coverage',
                    'Suntone is an expert of one-stop cross-border payment solutions and services in line with the development trend of the industry for cross-border trade, tourism and aviation, software games, digital copyright, education and training and many other cross-border Internet B2C(B) business models.'
                ]

            },
            itemList: {
                z: [
                    "教育培训",
                    "旅游酒店",
                    "跨境电商",
                    "国际航空",
                    "数字内容",
                    "软件游戏",
                    "零售",
                    "物流运输",
                    "商务出行",
                    "医疗美容",
                    "文化娱乐",
                    "公共事业",
                ],
                f: [
                    "教育培训",
                    "旅游酒店",
                    "跨境电商",
                    "国际航空",
                    "数字内容",
                    "软件游戏",
                    "零售",
                    "物流運輸",
                    "商務出行",
                    "醫療美容",
                    "文化娛樂",
                    "公共事業",
                ],
                e: [
                    'Education and training',
                    "tourist hotel",
                    'Cross-border e-commerce',
                    "International Aviation",
                    "Digital content",
                    "Software games",
                    "Retail",
                    "Logistics transportation",
                    "Business trip",
                    "Medical cosmetology",
                    "Culture and entertainment",
                    "public utilities",
                ],
            },
            images: [
                require('../assets/img/Overlay/Image - Header 5@2x.png'),
                require('../assets/img/Overlay/Image - Header 5.png'),
                require('../assets/img/Overlay/Image - Header 5@2x(1).png'),
                require('../assets/img/Overlay/Image - Header 5@2x(2).png'),
                require('../assets/img/Overlay/Image - Header 5@2x(3).png'),
                require('../assets/img/Overlay/Image - Header 5@2x(4).png'),
                require('../assets/img/Overlay/Image - Header 5f.png'),
                require('../assets/img/Overlay/Image - Header 5(2).png'),
                require('../assets/img/Overlay/Image - Header 5(4).png'),
                require('../assets/img/Overlay/Image - Header 5(1).png'),
                require('../assets/img/Overlay/Image - Header 5(3).png'),
                require('../assets/img/Overlay/Image - Header 5(5).png'),
            ],
            images1: [
                require('../assets/img/Overlay/horse-toy@2x.png'),
                require('../assets/img/Overlay/building-skyscraper@2x的副本.png'),
                require('../assets/img/Overlay/building-store@2x(1).png'),
                require('../assets/img/Overlay/plane-tilt@2x(1).png'),
                require('../assets/img/Overlay/brand-youtube@2x(1).png'),
                require('../assets/img/Overlay/device-gamepad-2@2x(1).png'),
                require('../assets/img/Overlay/shopping-bag(1).png'),
                require('../assets/img/Overlay/shopping-bag(11).png'),
                require('../assets/img/Overlay/shopping-bag(10).png'),
                require('../assets/img/Overlay/shopping-bag(9).png'),
                require('../assets/img/Overlay/shopping-bag(8).png'),
                require('../assets/img/Overlay/shopping-bag(7).png'),
            ],
            images2: [
                require('../assets/img/Overlay/horse-toy@2x的副本.png'),
                require('../assets/img/Overlay/building-skyscraper@2x.png'),
                require('../assets/img/Overlay/building-store@2x.png'),
                require('../assets/img/Overlay/plane-tilt@2x.png'),
                require('../assets/img/Overlay/brand-youtube@2x.png'),
                require('../assets/img/Overlay/device-gamepad-2@2x.png'),
                require('../assets/img/Overlay/shopping-bag.png'),
                require('../assets/img/Overlay/shopping-bag(2).png'),
                require('../assets/img/Overlay/shopping-bag(3).png'),
                require('../assets/img/Overlay/shopping-bag(4).png'),
                require('../assets/img/Overlay/shopping-bag(5).png'),
                require('../assets/img/Overlay/shopping-bag(6).png'),
            ],
            contType: "z",
            curIndex: 0,
            count: 2,
            phoneIndex: 0,
            swiperOption: {
                // swiper options 所有的配置同swiper官方api配置
                autoplay: {
                    delay: 5000,
                    disableOnInteraction: true,
                },   // 自动播放的时间间隔
                slidesPerView: 1.7,  //一次显示的数量
                direction: "horizontal", // 水平轮播,
                spaceBetween: 16,
                modules: [Autoplay],
            },
            swiper: null,
        };
    },
    methods: {
        move(e) {
            if (e.pageX > this.bodyW / 2) {
                this.position = "right";
            } else {
                this.position = "left";
            }
            if (e.pageY > 250) {
                this.position2 = "top";
            } else {
                this.position2 = "bottom";
            }
        },
        pageChange(index) {
            this.curIndex = index
            let left = 174 * index
            if (174 * (index - 2) > this.$refs.scroll.scrollLeft) {
                this.$refs.scroll.scrollLeft = 174 * (index - 2)
            }
            else if (left == 0) {
                this.$refs.scroll.scrollLeft = left
            }
        },
        clickPage(index) {
            this.$refs.page.setActiveItem(index + '')
        },
        clickNext() {
            if (this.curIndex == this.itemList.count - 1) {
                this.curIndex = 0
            } else {
                this.curIndex += 1
            }
            // if (this.curIndex != 1 && this.curIndex != 2) {
            this.pageChange(this.curIndex)
            //     this.clickPage(this.curIndex)
            // }

            this.clickPage(this.curIndex)
        },
        clickChangePage(index) {
            // this.$refs.mySwiper.slideTo(index);
            this.swiper.slideTo(index);
            console.log(this.$refs.mySwiper)
        },
        onSwiper(swiper) {
            this.swiper = swiper
            console.log('哈哈哈哈哈', swiper);
        },
        onSlideChange(swiper) {
            this.swiper = swiper
            this.phoneIndex = swiper.activeIndex
            console.log('slide change', swiper.activeIndex);
        },
        changeTypeTitleName() {
            if (this.contType == "f") {
                document.title = "行业覆盖";
            } else if (this.contType == 'e') {
                document.title = 'Industrial Coverage'
            } else {
                document.title = "行业覆盖";
            }
        }
    },

    mounted() {
        this.bodyW = document.body.clientWidth;
        this.bodyY = document.body.clientHeight;
        var that = this;
        this.contType = window.localStorage.getItem('language');
        that.changeTypeTitleName()
        window.addEventListener('setItemEvent', function (e) {
            if (e.key == "language") {
                that.contType = e.newValue;
                that.changeTypeTitleName()
            }
        })
        var wow = new WOW({
            boxClass: "wow",
            animateClass: "animated",
            offset: 40,
            mobile: true,
            live: true,
        });
        wow.init();
    },

};
</script>



<style src="../assets/css/Overlay-pc.css"  scoped></style>
<style src="../assets/css/Overlay-phone.css"  scoped></style>